<template>
    <div id="content-wrapper" class="vue-reservation-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="reservation-header">
                        <slot name="header"></slot>

                        <aut-router-links></aut-router-links>

                        <slot name="reviews"></slot>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <router-view
                        :usp-text="uspText"
                    ></router-view>
                </div>

                <aut-reservation-receipt
                    :class="$router.currentRoute.name"
                    :extra-kilometers-price="extraKilometersPrice"
                    :contact-person-business="contactPersonBusiness"
                ></aut-reservation-receipt>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RouterLinks from "./RouterLinks";
import analytics from "../../mixins/analytics";

export default {
    name: "ReservationWrapper",

    mixins: [analytics],

    components: {
        'aut-router-links': RouterLinks,
    },

    props: {
        disabledReservationDates: {
            type: Array,
            default: () => []
        },
        popupSettings: {
            type: Object,
            default: () => {}
        },
        uspText: {
            type: String,
            default: '',
        },
        extraKilometersPrice: {
            type: String,
            default: '',
        },
        contactPersonBusiness: {
            type: Array|Object,
            default: () => {},
            required: false
        }
    },

    mounted() {
        this.stopReservation();
    },

    created() {
        if (!lodash.isEmpty(this.disabledReservationDates)) {
            this.setDisabledReservationDates(this.disabledReservationDates);
        }

        if (!lodash.isEmpty(this.popupSettings)) {
            this.setPopUpSettings(this.popupSettings)
        }
    },

    computed: {
        ...mapGetters([
            'getVehicleRates',
            'getActiveVehicle',
            'getDays',
            'getActiveLocation',
            'getTotalVehicleRates'
        ]),
    },

    methods: {
        ...mapActions([
            'setDisabledReservationDates',
            'setPopUpSettings',
        ]),

        stopReservation() {
            let closeReservation = document.querySelectorAll('.block-fixed-block-contentstop-the-reservation .field--name-body a');

            if (!_.isNil(closeReservation)) {
                Array.from(closeReservation).forEach((button) => {
                    button.addEventListener("click", (e) => {
                        this.handleAnalyticsStopCheckout();
                    });
                });
            }
        },
    }
}
</script>
